"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return (vue_2.pushScopeId("data-v-49386918"), n = n(), vue_2.popScopeId(), n); };
var _hoisted_1 = { class: "swiper" };
var _hoisted_2 = { class: "swiper-wrapper" };
var _hoisted_3 = ["href"];
var _hoisted_4 = { class: "you-watched-block__img" };
var _hoisted_5 = ["src"];
var _hoisted_6 = {
    key: 1,
    class: "termi-image"
};
var _hoisted_7 = { class: "you-watched-block__right" };
var _hoisted_8 = { class: "you-watched-block__title" };
var _hoisted_9 = { class: "you-watched-block__price" };
var _hoisted_10 = /*#__PURE__*/ vue_2.createStaticVNode("<div class=\"slider-navigation wider-blue\" data-v-49386918><div class=\"arrow prev\" data-v-49386918><i class=\"termi-chevron-right\" data-v-49386918></i></div><div class=\"arrow next\" data-v-49386918><i class=\"termi-chevron-right\" data-v-49386918></i></div></div><div class=\"swiper-scrollbar\" data-v-49386918></div>", 2);
var vue_3 = require("vue");
exports.default = vue_1.defineComponent({
    name: 'App',
    setup: function (__props) {
        var watched = window.localStorage.getItem('watched');
        var slides = vue_3.ref(watched ? JSON.parse(watched) : []);
        var youWatchedSlider = vue_3.ref(null);
        vue_3.onMounted(function () {
            new window.Swiper(youWatchedSlider.value.querySelector('.swiper'), {
                slidesPerView: 'auto',
                spaceBetween: 30,
                navigation: {
                    prevEl: youWatchedSlider.value.querySelector('.arrow.prev'),
                    nextEl: youWatchedSlider.value.querySelector('.arrow.next'),
                },
                scrollbar: {
                    el: youWatchedSlider.value.querySelector('.swiper-scrollbar'),
                },
                breakpoints: {
                    1500: {
                        slidesPerView: 4,
                    }
                }
            });
        });
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                class: "you-watched-slider",
                ref_key: "youWatchedSlider",
                ref: youWatchedSlider
            }, [
                vue_2.createElementVNode("div", _hoisted_1, [
                    vue_2.createElementVNode("div", _hoisted_2, [
                        (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(slides.value, function (slide) {
                            return (vue_2.openBlock(), vue_2.createElementBlock("div", {
                                key: slide.id,
                                class: "swiper-slide"
                            }, [
                                vue_2.createElementVNode("a", {
                                    href: slide.url,
                                    class: "you-watched-block"
                                }, [
                                    vue_2.createElementVNode("div", _hoisted_4, [
                                        (slide.img)
                                            ? (vue_2.openBlock(), vue_2.createElementBlock("img", {
                                                key: 0,
                                                src: slide.img,
                                                alt: ""
                                            }, null, 8, _hoisted_5))
                                            : (vue_2.openBlock(), vue_2.createElementBlock("i", _hoisted_6))
                                    ]),
                                    vue_2.createElementVNode("div", _hoisted_7, [
                                        vue_2.createElementVNode("div", _hoisted_8, vue_2.toDisplayString(slide.title), 1),
                                        vue_2.createElementVNode("div", _hoisted_9, vue_2.toDisplayString(slide.cost), 1)
                                    ])
                                ], 8, _hoisted_3)
                            ]));
                        }), 128))
                    ])
                ]),
                _hoisted_10
            ], 512));
        };
    }
});
